import React, { useState } from 'react';
import { Button } from '@mui/material';

export function TagButton({
    title = '',
    text,
    id = '',
    color = "primary",
    endIcon = null,
    hoverIcon = null, // Nuevo prop para el icono al hacer hover
    href = "",
    onClick = () => { },
    sx = {},
    startIcon = null,
}) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            color={color}
            id={id}
            href={href}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)} // Maneja el evento hover
            onMouseLeave={() => setIsHovered(false)} // Resetea el evento hover
            sx={{
                borderRadius: "30px",
                color: "#ffffff",
                px: ".5rem",
                py: "2px",
                textTransform: "none",
                ...sx,
            }}
            variant="contained"
            startIcon={startIcon}
            endIcon={isHovered && hoverIcon ? hoverIcon : endIcon} // Cambia el icono dinamicamente
            title={title}
            target='_blank'
        >
            {text}
        </Button>
    );
}

export function TagHashButton({
    title = '',
    text,
    color = "primary",
    endIcon = null,
    hoverIcon = null, // Nuevo prop para el icono al hacer hover
    href = "",
    sx = {},
    startIcon = null,
}) {
    const [isHovered, setIsHovered] = useState(false);
    const hasHref = Boolean(href?.trim());

    return (
        <Button
            href={hasHref ? href : undefined}
            onMouseEnter={hasHref ? () => setIsHovered(true) : undefined} // Maneja el evento hover
            onMouseLeave={hasHref ? () => setIsHovered(false) : undefined} // Resetea el evento hover
            disableRipple={!hasHref}
            disableFocusRipple={!hasHref}
            disableTouchRipple={!hasHref}
            sx={{
                borderRadius: "4px",
                borderLeft: "4px solid #666B6E",
                backgroundColor: "#F0F0F1",
                color: "#666B6E",
                px: ".5rem",
                py: "2px",
                textTransform: "none",
                fontSize: "0.8rem",
                cursor: hasHref ? "pointer" : "default",
                "&:hover": {
                    backgroundColor: "#F0F0F1",
                },
                ...sx,
            }}
            variant={color}
            startIcon={startIcon}
            endIcon={isHovered && hoverIcon ? hoverIcon : endIcon} // Cambia el icono dinamicamente
            title={title}
            target={hasHref ? '_blank' : undefined}
        >
            {text}
        </Button>
    );
}

export default TagButton;
